// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__g4Ovi","light":"button_light__Anmwq","dark":"button_dark__FJMb_"};